export class Equipe {
  id: string;
  nome: string;
  celular: string;
  fone: string;
  descricao: string;
  fotoUrl: string;
}
